<template>
  <QS-scroller-box class="pr-0">
    <!-- 租赁信息 -->
    <QS-h4-title title="租赁信息"/>
    <!-- 确认租赁信息 -->
    <PersonalRentInfo
      ref="rentInfo"
      :planId="selectPlanId"
      :defaultRentInfo="leaseInfoParams"
      @updateInfo="updateRentDateInfo"
      @updateRentPlanList="updateRentPlanList"
      @plantIdChange="plantIdChange"
      @manualChangeStartStopDate="manualChangeStartStopDate"
    />

    <!-- 司机合作模式组件 -->
    <DriverCooperationRules
        ref="driverCooperRef"
        :rentDateInfo="rentDateInfo"
        :payPlanFee="payPlanFee"
        :sceneType="'signContract'"
        v-if="rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI"
        @autoAnchor="autoAnchor"
    />

    <!-- 租赁账单 -->
    <div v-else>
      <QS-h4-title title="租赁账单"/>
      <RentPlanConfig
        ref="RentPlanConfig"
        :defaultTableData="feeTableData"
        :rentDateInfo="rentDateInfo"
        :specialType="2"
        :scene="SCENE_TYPE.SIGN_CONTRACT"
        :configDisabled="configDisabled"
        @autoAnchor="autoAnchor"
        @tableDataChange="tableDataChange"
      />
    </div>


    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button v-if="previousStepShow" @click="previousStep" size="mini">上一步</el-button>
      <el-button @click="confirm" :loading="loading" size="mini" type="primary">确认，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
// API
import { bindCar } from '@/api/domain/carsService'
import { addPersonalOrderRenewalB } from '@/api/domain/underLease'

// 组件
import PersonalRentInfo from '@/components/RentPlanConfig/PersonalRentInfo/index.vue'
import RentPlanConfig from '@/components/RentPlanConfig'
import DriverCooperationRules from '@/components/DriverCooperationRules'

// 其他
import { isEmpty, omit } from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import { SCENE_TYPE } from '@/components/RentPlanConfig/config'
import { FEE_CODE_MAP, CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict'
import { addition, formatNumberWithCommas } from '@/utils'

export default {
  name: 'LeaseSetup',
  components: {
    PersonalRentInfo,
    RentPlanConfig,
    DriverCooperationRules,
  },
  props: {
    createOrderInfo: {
      type: Object,
      default: () => ({}),
    },
    ladderSchemeConfig: {
      type: Object,
      default: () => ({}),
    },
    leaseInfoParams: {
      type: Object,
      default: () => ({}),
    },
    tableDataFrom: {
      type: Object,
      default: () => ({}),
    },
    maitenaceParams: {
      type: Object,
      default: () => ({}),
    },
    leaseOrderDetailData: {
      type: Object,
      default: () => ({}),
    },
    // eslint-disable-next-line vue/no-unused-properties
    updateCarInfo: {
      type: Function,
      default: () => ({}),
    },
    defaultTable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      from_check: {}, // 校验结果
      modelList: [], // 车型列表
      rentPlanList: [], // 方案列表
      disableFlag: false, // 用于绑车禁用租赁类别
      // eslint-disable-next-line vue/no-unused-properties
      assignValue: null, // 队列中的值
      selectPlanId: null,
      rentDateInfo: {
        rentCategory: 1, // 类别，默认租车
        signDate: '', // 签署日期
        startStopDate: '', // 收款起止日期
        presentDays: '', // 赠送天数
        preFreeRentDays: '', // 前置免租天数
        isTranDeposit: '', // 是否平移原订单押金 1-是 0-否
        contractDateText: '', // 合同起止日期文本
        rentPeriodText: '', // 租期文本(天数)
        presentDaysText: '', // 赠送天数文本
        preFreeRentDaysText: '', // 前置免租天数文本
        contractDateText: '', // 合同起止日期文本 eg: 2023-07-01~2023-07-31
        rentPeriodText: '', // 租期文本(天数) eg: 共7天
        presentDaysText: '', // 赠送天数文本 eg: 0天
        allTotalAmount: '', // 总金额
        deposit: '', // 押金
        rentAmount: '', // 租金
        firstPayment: '', // 首付款
        fullPayment: '', // 全款
        otherAmount: '', // 其余收款项
      },
      payPlanFee: {},
      feeTableData: [],
      feeTableDataWithOrder: [],
      isModify: false,
      SCENE_TYPE, // 场景类型,
      loading: false, // 点击下一步loading
      CATEGORY_CODE_MAP,
    }
  },
  provide() {
    return {
      deposit: {
        flag: 0,
      },
      getPlanId: () => this.selectPlanId,
    }
  },
  watch: {
    // 监听订单状态
    'leaseOrderDetailData.state': {
      handler(val) {
        if (Number(val) === -1500) { // 待绑车，支付计划反显
          this.disableFlag = true
          // eslint-disable-next-line vue/no-mutating-props
          this.ladderSchemeConfig.disabledLeaseScheme = true //  租赁方案性质（固定还是阶梯）置灰
        }
      },
      deep: true,
      immediate: true,
    },
    // 租赁方案id有回填
    'createOrderInfo.model.c_leaseSchemeModel.planId': {
      async handler(val) {
        if (val) {
          // 选择非自定义租赁方案
          this.selectPlanId = val
          this.planChange(val, 'Assign')
        }
      },
      immediate: true,
    },
    // 监听 leaseInfoParams 中的 payPlanFee 字段变化
    leaseInfoParams: {
      handler(newVal) {
        if (newVal) {
          this.payPlanFee = newVal.payPlanFee
        }
      },
      immediate: true,
      deep: true,
    },
    defaultTable: {
      handler(val) {
        if (val && val.length) {
          this.feeTableData = val
        }
        this.feeTableDataWithOrder = val
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      categoryList: (state) => state.global.categoryList, // 类别
    }),
    previousStepShow() {
      return !this.$route.query.orderId
    },
    canNotClearPlanId() {
      const source = this.$route.query?.source
      const orderId = this.$route.query?.orderId
      return source || orderId
    },
    configDisabled() {
      if (!this.selectPlanId) {
        return false
      }
      return this.rentPlanList.some((item) => Number(this.selectPlanId) === Number(item.id))
    },

  },
  methods: {
    updateRentDateInfo(val, feeTableData, from) {
      this.rentDateInfo = {
        ...this.rentDateInfo,
        ...omit(val, ['allTotalAmount', 'deposit', 'rentAmount', 'firstPayment', 'fullPayment', 'otherAmount']),
      }

      if (val.rentCategory === 4) {
        if (val.payPlanFee) this.payPlanFee = val.payPlanFee
      } else {
        this.payPlanFee = null
      }

      if (from === 'fromEvent') {
        this.isModify = true
        this.feeTableData = feeTableData
        this.tableDataChange(feeTableData)
      }

      if (!this.isModify) {
        this.feeTableData = !isEmpty(this.feeTableDataWithOrder) ?
          this.feeTableDataWithOrder
          : feeTableData
      }
    },
    autoAnchor(toastFlag) {
      this.$refs.rentInfo.autoAnchorPoint(toastFlag)
    },
    // 2023-11-22线上问题修复 https://devops.aliyun.com/projex/project/83dc9efb9a32b55374287ac3e0/bug/a9d32bbb2aafced13a52b0c109
    setItemDataDisabled(refkey, key, status) {
      this.$refs[refkey] && this.$refs[refkey].setItemData({ elConfigKey: 'disabled', key, data: status })
    },
    // 租赁方案选择
    planChange(id) {
      this.selectPlanId = id
      if (!id) {
        this.$refs.rentInfo.resetFormData()
        const {
          model: {
            c_vehicleModelModel,
            c_leaseSchemeModel,
          },
        } = this.createOrderInfo
        // 租赁方案id (租赁商城单不能修改所以不用清除)
        if (!this.canNotClearPlanId) {
          c_leaseSchemeModel.planId = 0
        }
        // 车型选择
        c_vehicleModelModel.modelId = ''
        // 预租周期
        this.rentPeriod = null
        return
      }
      const selectedPlan = this.rentPlanList.find((item) => Number(id) === Number(item.id))
      if (selectedPlan) {
        const {
          model: {
            c_vehicleModelModel,
          },
        } = this.createOrderInfo
        // 回显订车车型
        c_vehicleModelModel.modelId = selectedPlan.modelId
        // eslint-disable-next-line vue/no-mutating-props
      }
      // 当选择为非自定义时候 车型 不可选
      this.$nextTick(() => {
        this.setItemDataDisabled('vehicleModel', 'modelId', true)
      })
    },
    // 取消
    cancel() {
      this.$emit('cancel')
    },
    // 上一步
    previousStep() {
      this.$emit('previousStep')
    },
    yajinDidNoFile(tableData) {
      const YA_JIN = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.YA_JIN)
      const flag = YA_JIN?.items?.some((v) => !v.startCycleDate || !v.endCycleDate)
      return YA_JIN?.payMode === 11 && flag
    },
    // 确认
    async confirm() {
      // 校验所有表单是否通过
      const isfin = Object.keys(this.from_check).every(
        (item) => this.from_check[item],
      )
      if (!isfin) {
        this.$message.error('请填写带有红色 * 的内容')
        return false
      }

      if (!this.$refs.rentInfo.getFormData()) return

      // eslint-disable-next-line vue/no-mutating-props
      this.leaseInfoParams = Object.assign(this.leaseInfoParams, this.$refs.rentInfo.getFormData())

      let payPlanFee = null

      if (
        this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI
      ) {
        // 获取司机合作模式表单
        payPlanFee = await this.$refs.driverCooperRef.getFormData()

        if (!payPlanFee) {
          this.$message.error('请填写司机规则带有红色 * 的内容')
          return
        }
      } else {
        // 获取租赁账单字段
        if (!this.$refs.RentPlanConfig.getFormData()) return false
        // eslint-disable-next-line vue/no-mutating-props
        const rentPlanData = this.$refs.RentPlanConfig.getFormData()
        if (!rentPlanData) return
        // eslint-disable-next-line vue/no-mutating-props
        this.tableDataFrom.tableData = rentPlanData || []
        if (this.yajinDidNoFile(this.tableDataFrom.tableData)) {
          this.$message.error('请将【押金】费项配置完成')
          return
        }
      }

      this.loading = true

      const params = { ...this.getParameter(), payPlanFee }

      // 商城单需要进行绑车操作
      const queryOrderId = this.$route.query?.orderId
      if (queryOrderId && Number(this.leaseOrderDetailData.source) === 2) {
        if (this.rentDateInfo.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
          params.orderAccruedPlans =
            !isEmpty(params.orderAccruedPlans) ?
              params.orderAccruedPlans :
              this.orderConfigInfo.orderAccruedPlans
        }


        params.customerId = params.customerId
          ?? this.orderConfigInfo.customerId
        params.startDate = params.startDate
          ?? this.orderConfigInfo.startDate
        params.endDate = params.endDate
          ?? this.orderConfigInfo.endDate

        const { code } = await bindCar(
          { ...params, orderId: queryOrderId },
        )

        this.loading = false

        if (code === 1) {
          if (queryOrderId) {
            this.$emit('confirm')
          } else {
            this.$router.replace({
              path: '/car_to_lease/forRentSignContract/personalSignContract',
              query: {
                stepsActive: 2, // 订单确认节点
                orderId: queryOrderId,
              },
            })
          }
          this.handelToppreview()
        }
      } else {
        this.addContract(params, queryOrderId)
      }
    },
    async addContract(params, queryOrderId) {
      const { code, data } = await addPersonalOrderRenewalB({
        ...params,
        orderId: queryOrderId,
      })

      this.loading = false

      if (code === 1) {
        if (queryOrderId) {
          this.$emit('confirm')
        } else {
          this.$message({
            message: '合同添加成功',
            type: 'success',
          })
          this.$router.replace({
            path: '/car_to_lease/forRentSignContract/personalSignContract',
            query: {
              stepsActive: 2,
              orderId: data.id,
            },
          })
        }
      }
    },
    // 获取提交参数
    getParameter() {
      const { leaseInfoParams, createOrderInfo, tableDataFrom, maitenaceParams } = this
      const {
        // 选择客户节点
        c_baseInfoModel,
        c_customerInfoModel,
        // 租赁设置节点
        c_leaseSchemeModel,
        c_vehicleModelModel,
        // 车辆选择
        c_vehicleSelectionModel,
        c_vehicleInfomodel,
      } = createOrderInfo.model
      // eslint-disable-next-line vue/no-mutating-props
      this.leaseInfoParams.startDate = this.leaseInfoParams.startStopDate[0]
      // eslint-disable-next-line vue/no-mutating-props
      this.leaseInfoParams.endDate = this.leaseInfoParams.startStopDate[1]

      return {
        ...c_vehicleSelectionModel,
        ...c_vehicleInfomodel,
        ...c_leaseSchemeModel,
        ...c_vehicleModelModel,
        ...c_baseInfoModel,
        ...c_customerInfoModel,
        ...maitenaceParams,
        ...leaseInfoParams,
        rentCategory: leaseInfoParams.rentCategory || leaseInfoParams.category,
        orderAccruedPlans: tableDataFrom.tableData || [],
        clueId: this.createOrderInfo.model.topPreviewModel.leadId,
        planId: this.rentDateInfo.planId,
      }
    },
    // 保存顶部预览数据
    handelToppreview() {
      const { model } = this.createOrderInfo
      const { c_leaseSchemeModel, c_vehicleModelModel, topPreviewModel } = model
      // 租赁方案
      const plan = this.rentPlanList.find((item) => {
        return c_leaseSchemeModel.planId === item.id
      })
      topPreviewModel.planName = plan?.name || ''
      // 修复sentry报错，找不到modelName问题
      if (c_vehicleModelModel.modelId) {
        // 订车车型
        const vehicleModel = this.modelList.find((item) => {
          return c_vehicleModelModel.modelId === item.modelId
        })
        topPreviewModel.modelName = vehicleModel?.modelName || ''
        topPreviewModel.modelId = c_vehicleModelModel.modelId
      }
      // 租赁类型
      const rentCategory = this.categoryList.find((item) => {
        return this.leaseInfoParams.rentCategory === item.code
      })
      topPreviewModel.categoryName = rentCategory.name

      // 收款起止日期
      topPreviewModel.startStopDate = `${moment(this.leaseInfoParams.startStopDate[0]).format('YYYY-MM-DD')}至${moment(this.leaseInfoParams.startStopDate[1]).format('YYYY-MM-DD')}`


      this.$EventBus.$emit('updateTopPreviewModel', topPreviewModel)
    },
    // 配置区数据变化
    tableDataChange(value) {
      const tableData = value
      // ② (押金、租金)或(首付款)，其余收款项
      const depositFeeData = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.YA_JIN) // 2-押金
      if (depositFeeData) {
        this.rentDateInfo.deposit = depositFeeData.isConfirm ? `${formatNumberWithCommas(depositFeeData?.totalAmount || 0)} 元` : '--'
      }
      const rentAmountFeeData = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.ZU_JIN) // 1-租金
      if (rentAmountFeeData) {
        // 0固定租金 1阶梯 2动态租金
        const rentAmount = rentAmountFeeData.payPlanType !== 2 ? `${formatNumberWithCommas(rentAmountFeeData?.totalAmount || 0)} 元` : `${rentAmountFeeData?.totalAmount || 0}元`
        this.rentDateInfo.rentAmount = rentAmountFeeData.isConfirm ? rentAmount : '--'
      }
      const firstPaymentFeeData = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) // 24-首付款
      if (firstPaymentFeeData) {
        this.rentDateInfo.firstPayment = firstPaymentFeeData.isConfirm ? `${formatNumberWithCommas(firstPaymentFeeData?.totalAmount || 0)} 元` : '--'
      }
      const fullPaymentFeeData = tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN) // 15-全款
      if (fullPaymentFeeData) {
        this.rentDateInfo.fullPayment = fullPaymentFeeData.isConfirm ? `${formatNumberWithCommas(fullPaymentFeeData?.totalAmount || 0)} 元` : '--'
      }
      // 其余收款项
      const otherTableFeeList = tableData.filter((item) => { // 1-租金 2-押金 15-全款 24-首付款
        return (Number(item.fundType) !== FEE_CODE_MAP.ZU_JIN &&
          Number(item.fundType) !== FEE_CODE_MAP.YA_JIN &&
          Number(item.fundType) !== FEE_CODE_MAP.QUAN_KUAN &&
          Number(item.fundType) !== FEE_CODE_MAP.SHOU_FU_KUAN)
      })
      if (otherTableFeeList.every((i) => i.isConfirm === false)) {
        this.rentDateInfo.otherAmount = '--'
      } else {
        const otherTableFeeTotalAmount = otherTableFeeList.reduce((sum, item) => {
          sum = addition(sum, item?.totalAmount || 0)
          return sum
        }, 0)
        this.rentDateInfo.otherAmount = `${formatNumberWithCommas(otherTableFeeTotalAmount)} 元`
      }
    },
    // 单独处理自定义方案时手动修改起止时间后清空表格内数据
    manualChangeStartStopDate() {
      if (this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        this.$refs.driverCooperRef.clearFormData()
      }
      if (!this.selectPlanId
        && this.rentDateInfo.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        const tableData = this.$refs.RentPlanConfig.getTableData()
        tableData.forEach((item) => {
          item.isConfirm = false
        })
        this.tableDataChange(tableData)
      }
    },
    updateRentPlanList(val) {
      this.rentPlanList = val
    },
    plantIdChange(val) {
      this.planChange(val)
    },
  },
}
</script>
<style lang="scss" scoped>
.pr-0 {
  padding-right: 0;
  ::v-deep .scrollerBox-content {
    padding-right: 0;
  }
}
</style>
